
/* global  browserUserControlActionHandler */

import { MagstimColor } from './../Magstim.Color'

export function magstim_saveHandler(value, additionalData, callback) {
    magstim_eventHandler('save', value, additionalData, callback);
}

export function magstim_clickHandler(value, additionalData, callback) {
    magstim_eventHandler('click', value, additionalData, callback);
}

export function magstim_eventHandler(eventName, value, additionalData, callback) {

    if ((typeof browserUserControlActionHandler !== "undefined") && (null !== browserUserControlActionHandler)) {

        if ((undefined !== value) && (null !== value) && (typeof value !== 'string') && !(value instanceof String)) {
            value = JSON.stringify(value);
        }

        if ((undefined !== additionalData) && (null !== additionalData) && (typeof additionalData !== 'string') && !(additionalData instanceof String)) {
            additionalData = JSON.stringify(additionalData);
        }

        console.log(`magstim_eventHandler : eventName=${eventName} value=${value} additionalData=${additionalData}`);

        const result = browserUserControlActionHandler.magstim_eventHandler(eventName, value, additionalData);

        result.then(function (retVal) {
            if ((undefined !== retVal) && (null !== retVal)) {
                console.log(`magstim_eventHandler : eventName=${eventName} value=${value} additionalData=${additionalData} returned=${retVal}`);
            }
        });
    }
    //DEBUG
    else {
        if (process.env.NODE_ENV !== "production") {
            if ((undefined !== value) && (null !== value) && (typeof value !== 'string') && !(value instanceof String)) {
                value = JSON.stringify(value);
            }

            if ((undefined !== additionalData) && (null !== additionalData) && (typeof additionalData !== 'string') && !(additionalData instanceof String)) {
                additionalData = JSON.stringify(additionalData);
            }

            // console.log(`magstim_eventHandler : eventName=${eventName} value=${value} additionalData=${additionalData}`);
        }
    }
    //DEBUG

    if(callback !== "undefined" && callback != null ){
        callback(eventName, value, additionalData);
    }
}


export const colours = MagstimColor;

export const styles = {

    dropdown: {
        marginLeft: '5px',
        marginRight: '5px',
        padding: '6px',
        borderRadisu: '4px'
    },
    dropdownTextArea: {
        borderWidth: 0,
        minWidth: 120,
        backgroundColor: colours.MagstimTextBackground,
        outlineWidth: 0
    },
    dropdownButton: {
        borderWidth: 0,
        backgroundColor: colours.MagstimGrey109,
        outlineWidth: 0
    },
    cardHeader: {
        fontFamily: 'Montserrat',
        fontSize: 18,
        fontWeight: 'bold',
        backgroundColor: colours.MagstimCardHeaderBackground,
        borderColor: colours.MagstimCardHeaderBackground,
        color: colours.MagstimGroupHeaderText
    },
    cardHeaderIcon: {
        fontSize: 18,
        paddingRight: 6,
        backgroundColor: colours.MagstimCardHeaderBackground,
        borderColor: colours.MagstimCardHeaderBackground,
        color: colours.MagstimGroupHeaderText
    },
    cardHeaderButton: {
        backgroundColor: colours.MagstimCardHeaderBackground,
        borderColor: colours.MagstimCardHeaderBackground,
        color: colours.MagstimGroupHeaderText,
        padding: '0px'
    },
    cardHeaderAddButton: {
        backgroundColor: colours.MagstimPrimaryButton,
        borderColor: colours.MagstimPrimaryButton,
        color: colours.MagstimWhite,
        width: '300px'
    },
    cardBody: {
        backgroundColor: colours.MagstimGroupBackground,
        borderColor: colours.MagstimGroupBackground
    },
    cardBodyNoPadding: {
        backgroundColor: colours.MagstimGroupBackground,
        borderColor: colours.MagstimGroupBackground,
        padding: 0
    },
    transparent: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        padding: 0
    },
    cardBodyText: {
        color: colours.MagstimWhite,
        minHeight: '48px'
    },
    listItem: {
        backgroundColor: colours.MagstimTextBackground,
        borderColor: colours.MagstimTextBackground,
        color: colours.MagstimWhite,
        minHeight: '48px',
        margin: '4px'
    },
    saveButton: {
        backgroundColor: colours.MagstimPrimaryButton,
        borderColor: colours.MagstimPrimaryButton,
        width: '200px',
        minHeight: '48px'
    },
    infoIcon: {
        backgroundColor: 'transparent',
        color: colours.MagstimGreen,
        width: '200px',
        fontSize: '40px'
    },
    VerticalNumberAndLabel: {
        padding: '10px',
        backgroundColor: 'transparent',
        verticalAlign: 'bottom',
        alignSelf: 'flex-end'
    },
    ValueEntryRow: {
        minHeight: '120px',
        backgroundColor: 'transparent'
    },
    VisualisationCell: {
        backgroundColor: 'blue',
        minHeight: '500px'
    },
    magstimFormControlCenter: {
        backgroundColor: colours.MagstimTextBackground,
        borderColor: colours.MagstimTextBackground,
        color: 'white',
        minHeight: '48px',
        width: '150px',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        textAlign: 'center'
    },
    magstimFormControlLeft: {
        backgroundColor: colours.MagstimTextBackground,
        borderColor: colours.MagstimTextBackground,
        color: 'white',
        minHeight: '48px',
        margin: '0',
        textAlign: 'left'
    }
};

